import { handleActions } from "redux-actions";
import decode from "jwt-decode";
import produce from "immer";
import {
  CLEAR_AUTH,
  CLEAR_TOKEN,
  FAIL_AUTH,
  SUCCESS_AUTH,
} from "../constants/actionTypes";
import { authenticated, error, token, username } from "../constants/labels";

export default handleActions(
  {
    [CLEAR_AUTH]: produce((state) => (state = {})),
    [FAIL_AUTH]: produce((state, action) => {
      // notification.error({
      //     message: 'Error',
      //     description: action.payload
      // })
      state[error] = action.payload;
      state[authenticated] = false;
      state[token] = undefined;
    }),
    [SUCCESS_AUTH]: produce((state, action) => {
      state[authenticated] = true;
      const decodeValue = decode(action.payload.authorization);
      state[token] = action.payload.authorization;
      state[username] = decodeValue.sub;
      // state[error] = ''
    }),
    [CLEAR_TOKEN]: produce((state) => {
      state[error] = "";
      state[token] = undefined;
      state[authenticated] = false;
      state[username] = "";
    }),
  },
  { authenticated: false }
);